<template>
  <div class="group" :class="wrapperClass">
    <input
      :id="id"
      v-bind="attrs"
      type="checkbox"
      class="sr-only peer"
    >
    <label :for="id" :class="labelClass" class="peer-checked:bg-grey-50 hover:bg-grey-50/50 py-3 px-4 flex items-center cursor-pointer antialiased leading-none select-none text-sm">
      <slot name="checkmark">
        <span class="checkbox inline-grid place-content-center self-start p-1 size-6 border rounded bg-surface-raised text-white group-has-[input:focus-visible]:border-grey-950 group-has-[input:focus-visible]:ring-1 ring-grey-950 group-has-[input:checked]:bg-red-800 group-has-[input:checked]:border-red-800 overflow-hidden">
          <CheckIcon class="size-5 hidden group-has-[input:checked]:block" stroke-width="4" aria-hidden="true" />
        </span>
      </slot>
      <span v-if="label" class="ml-2" v-text="label" />
      <span v-if="addition" class="ml-auto pl-6 text-xs text-muted" v-text="addition" />
    </label>
  </div>
</template>

<script setup lang="ts">
import { CheckIcon } from '@heroicons/vue/24/outline'

defineProps({
  id: {
    type: String,
    required: true
  },
  label: {
    type: String,
    required: false,
    default: ''
  },
  addition: {
    type: String,
    required: false,
    default: ''
  },
  wrapperClass: {
    type: [Object, Array, String],
    required: false,
    default: ''
  },
  labelClass: {
    type: [Object, Array, String],
    required: false,
    default: ''
  }
})

defineOptions({
  inheritAttrs: false
})

const attrs = useAttrs()
</script>
